import React from 'react'
import styles from './SportTypes.module.css'
import { Sports } from '../types'
import { useDispatch } from 'react-redux'
import { selectSportType, setDefaultLiveState } from '../LiveSlice'
import { useHistory } from 'react-router-dom'

export interface Props extends Sports {
  hasSportCount: boolean
  scrollTopLiveList: (index: number) => void
}

const SportTypes = ({
  Id,
  IsTopLeague,
  HasTopLeague,
  Active,
  SportTypeName,
  CurrentGameCount,
  hasSportCount,
  scrollTopLiveList,
}: Props & { ref: React.Ref<HTMLButtonElement> }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const sportTypeClick = (sportTypeId: string) => {
    scrollTopLiveList(0)
    dispatch(selectSportType({ sportTypeId }))
    dispatch(setDefaultLiveState())
    //dispatch(fetchLiveSportTypes())
    //dispatch(fetchLiveChampionships())
    history.push(`/live/${sportTypeId}`)
  }

  return (
    <a
      onClick={() => sportTypeClick(Id)}
      className={`${styles.sportType} ${
        Active === 'active' ? styles.active : ''
      }`}
    >
      <span
        className={`MobSportType${Id} ${styles['MobSportType' + Id]}  ${
          styles.sportTypeIcon
        }`}
      ></span>
      {SportTypeName}
      {hasSportCount ? (
        <span className={styles.sportTypeCount}>{CurrentGameCount}</span>
      ) : (
        ''
      )}
    </a>
  )
}

export default React.memo(SportTypes)